import type { AutomationFailureMetrics } from '@urbanx/agx.support.client';
import { AgxMetric, AgxSpacer } from '@urbanx/agx.ui-components2';

interface AutomationErrorMetricsProps {
  metrics?: AutomationFailureMetrics;
}

const AutomationErrorMetrics = ({ metrics }: AutomationErrorMetricsProps) => (
  <AgxSpacer direction="horizontal" gap="sm" fill wrap>
    <div style={{ flex: '1 1 220px' }}>
      <AgxMetric title="Today's unresolved" metric={metrics?.todayUnresolved ?? '--'} />
    </div>
    <div style={{ flex: '1 1 220px' }}>
      <AgxMetric title="Last 7 days unresolved" metric={metrics?.lastSevenDaysUnresolved ?? '--'} />
    </div>
    <div style={{ flex: '1 1 220px' }}>
      <AgxMetric title="Total unresolved" metric={metrics?.totalUnresolved ?? '--'} />
    </div>
    <div style={{ flex: '1 1 220px' }}>
      <AgxMetric title="Total errors" metric={metrics?.totalErrors ?? '--'} />
    </div>
  </AgxSpacer>
);

export default AutomationErrorMetrics;
